import React from "react";
import { Input, Form, FormControl, SelectPicker, Schema } from "rsuite";

import { debounce, hasErrorObject } from "utils";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";

const { StringType, BooleanType } = Schema.Types;

const model = Schema.Model({
    senderid: StringType()
        .minLength(3, "Min characters 3").maxLength(40, "Max characters 40"),
    language: StringType()
        .minLength(2, "Min characters 2").maxLength(40, "Max characters 40"),
    supplier_id: StringType(),
    mcc_mnc: StringType(),
    dialer_id: StringType(),
    do_not_send: BooleanType()
});


export default ({
    loading,
    dialerList,
    mccMncList,
    supplierList,
    defaultFilter,
    onChangeFilter
}) => {

    return (
        <>
            <Form
                model={model}
                formDefaultValue={defaultFilter}
                onChange={debounce((formValue) => {
                    const formCheckData = model.check(formValue);
                    if (!hasErrorObject(formCheckData)) {
                        onChangeFilter(formValue);
                    }
                }, 800)}
            >
                <FlexGrid align="middle">
                    <FlexGridItem>
                        <FormControl
                            accepter={Input}
                            name="senderid"
                            placeholder="Sended ID..."
                            style={{ width: 220 }}
                        />
                    </FlexGridItem>
                    <FlexGridItem>
                        <FormControl
                            accepter={Input}
                            name="language"
                            placeholder="Language..."
                            style={{ width: 120 }}
                        />
                    </FlexGridItem>
                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            data={supplierList}
                            disabled={loading}
                            loading={loading}
                            name="supplier_id"
                            labelKey="name"
                            valueKey="supplier_id"
                            placeholder="Supplier..."
                            style={{ width: 220 }}
                        />
                    </FlexGridItem>
                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            data={mccMncList}
                            name="mcc_mnc"
                            labelKey="nameMccMnc"
                            valueKey="mcc_mnc"
                            placeholder="Destination..."
                            style={{ width: 220 }}
                        />
                    </FlexGridItem>
                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            data={dialerList}
                            disabled={loading}
                            loading={loading}
                            name="dialer_id"
                            labelKey="name"
                            valueKey="id"
                            placeholder="Dialer..."
                            style={{ width: 220 }}
                        />
                    </FlexGridItem>
                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            data={[{ value: true, label: "Do not send" }, { value: false, label: "Send" }]}
                            name="do_not_send"
                            valueKey="value"
                            labelKey="label"
                            placement="autoVertical"
                            placeholder="Do not send..."
                            searchable={false}
                            style={{ width: 130 }}
                        />
                    </FlexGridItem>
                </FlexGrid>
            </Form>
        </>
    );
};
